export const microformMonthOptions = Array.from({ length: 12 }, (_, i) => (i + 1 < 10 ? '0' + (i + 1) : i + 1)); // 12 months;
export const MONTH_LABELS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
